import React from 'react'

import Translator from 'bazinga-translator'

import Button from '../../../../components/Btn'
import Classified from '../../../../components/Tournaments/Tournament/Header/Classified'
import TimeToEnd from '../../../../components/Tournaments/Tournament/Header/TimeToEnd'
import { GET_TOURNAMENT_DETAILS_URL } from '../../../Tournaments/constants'
import { TournamentWithMembership } from '../../../Tournaments/types/Tournament'
import { ContentWrapper } from './styles/Content'
import { StyledHeaderWrapper } from './styles/Wrapper'

type Props = Pick<TournamentWithMembership, 'id' | 'finishDate' | 'userMembership'>

export function Footer({ id, finishDate, userMembership }: Props) {
  const link = GET_TOURNAMENT_DETAILS_URL(id)

  return (
    <StyledHeaderWrapper>
      <ContentWrapper>
        <Classified userMembership={userMembership} />
        <TimeToEnd finishDate={finishDate} />
      </ContentWrapper>
      <Button
        to={link}
        link
        secondary
        sm
      >
        {Translator.trans('details', {}, 'tournaments')}
      </Button>
    </StyledHeaderWrapper>
  )
}
